<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12)
      div(v-if='canWithdraw&&hadData')
        withdraw-page(v-if='status1', @success='changeStatus')
        success-page.mt-12(v-if='status2')
      div(v-else-if='hadData')
        status-page(:bank-info='bankInfo')
</template>
<script> 
import { agentBanks as apiAgentBanks } from '@/apis'
import withdrawPage from './childs/withdraw'
import successPage from './childs/succes'
import statusPage from './childs/status'

export default {
  components : {
    withdrawPage,
    successPage,
    statusPage
  },
  data () {
    return {
      hadData:false,
      canWithdraw:true,
      status1:true,
      status2:false,
      bankInfo : {}
    }
  },
  async created () {
    await this.getStatusWithdraw()
  },
  methods : {

    changeStatus () {
      this.status1 = false,
      this.status2 = true
    },

    async getStatusWithdraw (params = {}) {

      params.transaction_type_id = 2

      const [err, data,,,status] = await apiAgentBanks.get(params)

      this.hadData = true 

      if(status === 400){  
        this.canWithdraw = false 
        this.bankInfo = data 
      }  

      if(err){
        return
      }
    }
  }
}
</script>